import React from "react";
import { PropTypes } from "prop-types";
import { Link } from "@mui/material";
import SFTypography from "../typography";
import useStyled from "../../hooks/useStyled";

const { styled } = useStyled();

const StyledContainer = styled("div", { shouldForwardProp: false })(
  ({ theme, iconPosition }) => ({
    display: "flex",
    "& .heading-container": {
      alignItems: "center",
      display: "flex",
      flexDirection: iconPosition === "left" ? "row-reverse" : "row",
      "& .MuiTypography-root": {
        ...(iconPosition === "left"
          ? { paddingLeft: theme.spacing(1) }
          : { paddingRight: theme.spacing(1) }),
      },
    },
  })
);

const SFLinkButton = (props) => {
  const underline = "none";
  return (
    <StyledContainer iconPosition={props.iconPosition}>
      <Link component={"button"} onClick={props.onClick} underline={underline}>
        <div className="heading-container">
          <SFTypography
            component="div"
            variant={props.variant}
            color={props.color}
          >
            {props.text}
          </SFTypography>
          {props.icon}
        </div>
      </Link>
    </StyledContainer>
  );
};

SFLinkButton.defaultProps = {
  color: "blue500",
  iconPosition: "right",
};

SFLinkButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  icon: PropTypes.node,
  color: PropTypes.string,
  iconPosition: PropTypes.oneOf(["left", "right"]),
};

export default SFLinkButton;
